var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_418_111)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.157 29.8945C25.157 29.2725 25.2795 28.6566 25.5175 28.0819C25.7556 27.5072 26.1045 26.985 26.5443 26.5452C26.9842 26.1053 27.5064 25.7564 28.081 25.5184C28.6557 25.2803 29.2717 25.1578 29.8937 25.1578C30.5157 25.1578 31.1317 25.2803 31.7064 25.5184C32.2811 25.7564 32.8032 26.1053 33.2431 26.5452C33.6829 26.985 34.0318 27.5072 34.2699 28.0819C34.5079 28.6566 34.6304 29.2725 34.6304 29.8945C34.6304 31.1508 34.1314 32.3556 33.2431 33.2439C32.3548 34.1322 31.15 34.6313 29.8937 34.6313C28.6374 34.6313 27.4326 34.1322 26.5443 33.2439C25.656 32.3556 25.157 31.1508 25.157 29.8945ZM29.8937 22C28.6627 22.0001 27.4487 22.2881 26.3489 22.841C25.249 23.3939 24.2936 24.1964 23.5592 25.1843C22.8247 26.1722 22.3314 27.3181 22.1187 28.5306C21.906 29.7432 21.9799 30.9886 22.3343 32.1675C22.6887 33.3464 23.3139 34.4261 24.16 35.3203C25.006 36.2145 26.0495 36.8984 27.207 37.3175C28.3645 37.7366 29.6039 37.8792 30.8264 37.7339C32.0488 37.5886 33.2203 37.1594 34.2473 36.4807L39.3029 41.5374C39.5991 41.8336 40.0009 42 40.4198 42C40.8386 42 41.2404 41.8336 41.5366 41.5374C41.8328 41.2412 41.9992 40.8395 41.9992 40.4206C41.9992 40.0017 41.8328 39.6 41.5366 39.3038L36.4799 34.2481C37.2664 33.0583 37.716 31.6775 37.7807 30.2526C37.8454 28.8277 37.5228 27.4119 36.8473 26.1557C36.1718 24.8994 35.1685 23.8497 33.9442 23.118C32.7198 22.3862 31.3201 21.9999 29.8937 22Z",
    fill: "#535B6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_418_111",
    x: 0,
    y: 0,
    width: 57.9991,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_418_111"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.65098 0 0 0 0 0.705882 0 0 0 0 0.784314 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_418_111"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_418_111",
    result: "effect2_dropShadow_418_111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_418_111",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.549e6d7e8f1259af702405a94f4bde4d.svg";
export { ForwardRef as ReactComponent };